import React from 'react';

import { Container, Title, ExpandIcon } from './styles';

const ServerName: React.FC = () => {
  return (
    <Container>
      <Title>Server Name</Title>
      <ExpandIcon />
    </Container>
  );
};

export default ServerName;
